import { H1 } from "@holigral/shared/ui/components"
import { TenantCreateForm } from "@/tenant"
import { Golden } from "@/ui"
import { useT } from "@/i18n"

export default function OnboardingPage() {
  const { t } = useT("auth")

  return (
    <Golden className="h-screen">
      <H1>{t("nameWorkspace")}</H1>
      <div className="m-4 w-sm">
        <TenantCreateForm />
      </div>
    </Golden>
  )
}
